export default __webpack_public_path__ + "static/media/ordersIcon.051f3ed1.svg";